/**
 * Страница спецификации проекта (user/projectspec).
 *
 * Маркер инициализации — #spec-table-container.
 * Конфиг — window.projectSpecConfig (csrfToken, projectId, routes, roomOptions, i18n).
 *
 * Функционал:
 *   - кнопка "+ Add product" в каждой комнате открывает ProductSelectionModal
 *     с контекстом 'specification' и AJAX-ом добавляет товар в спеку;
 *   - кнопка "+ Add room" (id=add-room-trigger-spec) — выбор типа комнаты + AJAX-создание.
 *
 * Read-only режим — определяется window.specReadOnly.
 */

function init() {
    if (!document.getElementById('spec-table-container')) return;
    if (window.specReadOnly) return;

    const config = window.projectSpecConfig;
    if (!config) {
        console.error('[project-spec] window.projectSpecConfig not found');
        return;
    }

    const $ = window.jQuery || window.$;
    if (!$) {
        console.error('[project-spec] jQuery not loaded');
        return;
    }
    const showToast = window.showToast || function () {};

    function bindAddProductButtons() {
        $('.button_add_product').off('click').on('click', function (e) {
            e.preventDefault();
            e.stopPropagation();
            const roomId = $(this).data('id');
            const ProductSelectionModal = window.ProductSelectionModal;
            if (!ProductSelectionModal) {
                console.error('[project-spec] ProductSelectionModal is not loaded');
                return;
            }
            ProductSelectionModal.open({
                context: 'specification',
                data: { roomId, projectId: config.projectId },
                onSelect: addProductToSpecification,
            });
        });
    }
    window.bindAddProductButtons = bindAddProductButtons;

    function addProductToSpecification(result) {
        const product = result.product;
        const sizeIndex = result.sizeIndex;
        const roomId = result.data.roomId;
        const quantity = result.quantity || 1;

        // Цена в зависимости от выбранного размера
        let price = product.price;
        if (product.size) {
            try {
                const sizes = JSON.parse(product.size);
                if (sizes[sizeIndex] && sizes[sizeIndex].price_from) {
                    price = sizes[sizeIndex].price_from;
                }
            } catch (e) {
                console.error('Error parsing size data:', e);
            }
        }

        $.ajax({
            url: '/addproducttospec',
            method: 'POST',
            data: {
                _token: config.csrfToken,
                project_id: config.projectId,
                room_id: roomId,
                product_id: product.id,
                size_index: sizeIndex,
                product_qty: quantity,
                price,
            },
            success() {
                window.location.reload();
            },
            error() {
                showToast('error', config.i18n.errorAddingProduct);
            },
        });
    }

    function addRoomToProject(roomName) {
        $.ajax({
            url: config.routes.addRoom,
            method: 'POST',
            data: {
                _token: config.csrfToken,
                project_id: config.projectId,
                name: roomName,
                room_type: roomName,
            },
            success() {
                showToast('success', config.i18n.roomCreated);
                setTimeout(() => window.location.reload(), 1000);
            },
            error() {
                showToast('error', config.i18n.errorCreatingRoom);
            },
        });
    }

    $(() => {
        bindAddProductButtons();
        $(document).ajaxComplete(bindAddProductButtons);

        $('#add-room-trigger-spec').on('click', function (e) {
            e.preventDefault();
            if (!window.showSelectModal) return;

            window.showSelectModal({
                title: config.i18n.addRoom,
                placeholder: '',
                items: config.roomOptions,
                confirmText: config.i18n.addRoomBtn,
                cancelText: config.i18n.cancel,
            }).then(selectedRoom => {
                if (!selectedRoom) return;
                if (selectedRoom === 'other') {
                    window.showInputModal({
                        title: config.i18n.enterRoomName,
                        placeholder: '',
                        confirmText: config.i18n.addRoomBtn,
                        cancelText: config.i18n.cancel,
                    }).then(customRoomName => {
                        if (customRoomName) addRoomToProject(customRoomName);
                    });
                } else {
                    addRoomToProject(selectedRoom);
                }
            });
        });
    });
}

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
} else {
    init();
}
